export interface StringOption {
    value: string;
    label: string;
}

export interface AnyData {
    [key: string]: any;
}

export enum EnumSkillRetrieverFields {
    VECTOR_STORAGE = 'vector_storage',
    DATABASE = 'database',
    SBX = 'sbx',
    EXCEL = 'excel',
    REPORT = 'report'
}
